module.exports = __webpack_public_path__ + "static/img/empty-reward-default.77d80a86.png";